import { SvgIcon } from '@material-ui/core'

export default function BoostIcon(props: any) {
    return (
        <SvgIcon viewBox="0 0 19 24" fill="none" {...props}>
            <path
                d="M10.0192 6.04604C10.1307 5.15429 9.01013 4.66785 8.4348 5.35825L2.63014 12.3238C2.14165 12.91 2.55849 13.8 3.32154 13.8H8.4805C9.02185 13.8 9.44069 14.2745 9.37355 14.8116L8.98076 17.954C8.86929 18.8457 9.98988 19.3321 10.5652 18.6418L16.3699 11.6762C16.8584 11.09 16.4415 10.2 15.6785 10.2H10.5195C9.97816 10.2 9.55931 9.72554 9.62646 9.18837L10.0192 6.04604Z"
                fill="currentColor"
                stroke="currentColor"
                strokeWidth="0.9"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </SvgIcon>
    )
}
